const resources = {
  "en": {
    "supportHelp": {
      "title": "Support & Help",
      "description": "Find quick answers or reach our support team with a detailed request.",
      "sections": {
        "faqTitle": "Common questions",
        "faqDescription": "Start here for the answers people usually need before opening a support request."
      },
      "faqTitle": "Frequently asked questions",
      "faq": [
        {
          "question": "What is FinApp and what is it not?",
          "answer": "FinApp is a manual finance workspace for tracking accounts, budgets, forecasts, and goals. It is not a bank and does not provide financial, tax, or legal advice."
        },
        {
          "question": "Do you connect to my bank or sync transactions automatically?",
          "answer": "No. FinApp relies on manual entries so you stay in control of your data and assumptions."
        },
        {
          "question": "How do subscriptions and cancellation work?",
          "answer": "Paid plans renew on the billing cycle shown at checkout. You can cancel anytime; access remains active until the end of the paid period. Manage this in Settings → Subscription."
        },
        {
          "question": "Do you offer refunds?",
          "answer": "Refund requests are reviewed by support. We do not promise automatic refunds or refunds for partial periods unless required by law. See the Refund Policy for details."
        },
        {
          "question": "Can I export or delete my data?",
          "answer": "Yes. The app provides account data export and account deletion tools. Some internal security, audit, billing, anti-abuse, or backup records may be excluded or retained when needed."
        },
        {
          "question": "How should I report a privacy or security concern?",
          "answer": "Open a support request and choose the closest privacy, security, account access, or billing topic. Include your account email, issue category, and approximate time. Do not send passwords or payment card data."
        },
        {
          "question": "Where can I read the official policies?",
          "answer": "Use the links below to open About, Terms of Service, Privacy Policy, and Refund Policy."
        }
      ],
      "form": {
        "title": "Contact support",
        "subtitle": "We usually reply within 1–2 business days.",
        "replyWindow": "Typical reply window",
        "goalLabel": "Support goal",
        "goalPlaceholder": "Choose a topic",
        "goalRequired": "Select a support goal.",
        "goals": [
          {"value": "billing_plans", "label": "Billing/Plans"},
          {"value": "privacy_export", "label": "Data export or privacy question"},
          {"value": "account_deletion", "label": "Account deletion help"},
          {"value": "security_report", "label": "Security issue report"},
          {"value": "bug", "label": "Bug"},
          {"value": "feature_request", "label": "Feature request"},
          {"value": "account_access", "label": "Account access"},
          {"value": "other", "label": "Other"}
        ],
        "descriptionLabel": "Issue details",
        "descriptionPlaceholder": "Include your account email, issue category, approximate time, and steps to reproduce if relevant. Do not send passwords or payment card data.",
        "descriptionRequired": "Provide a short description.",
        "safetyTitle": "What to include",
        "safetyDescription": "Include the account email, issue category, approximate time, and relevant context. Do not send passwords, payment card numbers, one-time codes, or other secrets.",
        "emailLabel": "Contact email",
        "emailPlaceholder": "you@example.com",
        "emailRequired": "Enter a contact email.",
        "emailInvalid": "Enter a valid email address.",
        "submit": "Submit request",
        "successTitle": "Thanks! Your request is on its way.",
        "successDescription": "We received your message. Typical reply time: 24–48 hours.",
        "successToast": "Support request submitted.",
        "errorToast": "Unable to send your request. Please try again.",
        "errorValidation": "Please review the highlighted fields and try again.",
        "errorAlreadySubmitted": "We already have your request. Please wait for our reply.",
        "errorRateLimit": "You have reached the request limit. Please wait and try again.",
        "errorServer": "Something went wrong on our side. Please try again shortly.",
        "submitAnother": "Submit another request"
      }
    }
  },
  "uk": {
    "supportHelp": {
      "title": "Підтримка та допомога",
      "description": "Знайдіть швидкі відповіді або зверніться до служби підтримки з детальним запитом.",
      "sections": {
        "faqTitle": "Типові запитання",
        "faqDescription": "Почніть із відповідей, які найчастіше потрібні ще до звернення в підтримку."
      },
      "faqTitle": "Поширені запитання",
      "faq": [
        {
          "question": "Що таке FinApp і чим він не є?",
          "answer": "FinApp — це простір для ручного обліку рахунків, бюджетів, прогнозів і цілей. Це не банк і не сервіс фінансових, податкових чи юридичних консультацій."
        },
        {
          "question": "Чи підключаєте ви банк або автоматично синхронізуєте транзакції?",
          "answer": "Ні. FinApp працює на ручному введенні, щоб ви контролювали всі дані та припущення."
        },
        {
          "question": "Як працюють підписки та скасування?",
          "answer": "Платні плани поновлюються за платіжним циклом. Скасувати можна будь-коли; доступ зберігається до кінця оплаченого періоду. Керуйте цим у Налаштування → Підписка."
        },
        {
          "question": "Чи можливе повернення коштів?",
          "answer": "Запити на повернення розглядає підтримка. Ми не обіцяємо автоматичні повернення або повернення за неповний період, якщо цього не вимагає закон. Деталі дивіться у політиці Refund."
        },
        {
          "question": "Чи можу я експортувати або видалити свої дані?",
          "answer": "Так. У застосунку є інструменти експорту даних акаунта та видалення акаунта. Деякі внутрішні записи безпеки, аудиту, білінгу, anti-abuse або резервні копії можуть бути виключені чи збережені, коли це потрібно."
        },
        {
          "question": "Як повідомити про privacy або security проблему?",
          "answer": "Створіть звернення в підтримку й оберіть найближчу тему: privacy, security, доступ до акаунта або білінг. Вкажіть email акаунта, категорію, приблизний час. Не надсилайте паролі або дані платіжних карт."
        },
        {
          "question": "Де прочитати офіційні політики?",
          "answer": "Скористайтеся посиланнями нижче, щоб відкрити About, Terms of Service, Privacy Policy та Refund Policy."
        }
      ],
      "form": {
        "title": "Звернутися до підтримки",
        "subtitle": "Зазвичай відповідаємо протягом 1–2 робочих днів.",
        "replyWindow": "Типовий час відповіді",
        "goalLabel": "Ціль звернення",
        "goalPlaceholder": "Оберіть тему",
        "goalRequired": "Оберіть ціль звернення.",
        "goals": [
          {"value": "billing_plans", "label": "Оплата/плани"},
          {"value": "privacy_export", "label": "Експорт даних або privacy-питання"},
          {"value": "account_deletion", "label": "Допомога з видаленням акаунта"},
          {"value": "security_report", "label": "Повідомити про security issue"},
          {"value": "bug", "label": "Помилка"},
          {"value": "feature_request", "label": "Запит на функцію"},
          {"value": "account_access", "label": "Доступ до акаунта"},
          {"value": "other", "label": "Інше"}
        ],
        "descriptionLabel": "Суть проблеми",
        "descriptionPlaceholder": "Вкажіть email акаунта, категорію питання, приблизний час і кроки відтворення, якщо доречно. Не надсилайте паролі або дані платіжних карт.",
        "descriptionRequired": "Додайте короткий опис.",
        "safetyTitle": "Що вказати",
        "safetyDescription": "Вкажіть email акаунта, категорію питання, приблизний час і релевантний контекст. Не надсилайте паролі, номери платіжних карт, одноразові коди або інші секрети.",
        "emailLabel": "Контактний email",
        "emailPlaceholder": "you@example.com",
        "emailRequired": "Вкажіть контактний email.",
        "emailInvalid": "Вкажіть коректну email-адресу.",
        "submit": "Надіслати запит",
        "successTitle": "Дякуємо! Ваш запит надіслано.",
        "successDescription": "Ми отримали ваше повідомлення. Зазвичай відповідаємо протягом 24–48 годин.",
        "successToast": "Запит до підтримки надіслано.",
        "errorToast": "Не вдалося надіслати запит. Спробуйте ще раз.",
        "errorValidation": "Перевірте підсвічені поля та спробуйте ще раз.",
        "errorAlreadySubmitted": "Ми вже отримали ваше звернення. Будь ласка, дочекайтеся відповіді.",
        "errorRateLimit": "Ви досягли ліміту запитів. Зачекайте й спробуйте пізніше.",
        "errorServer": "Сталася помилка на нашому боці. Спробуйте ще раз трохи пізніше.",
        "submitAnother": "Надіслати ще один запит"
      }
    }
  }
};

export default resources;
